import { IdleTimeoutModal } from '@/components/idle-timeout-modal';
import { useIdleTimeout } from '@/hooks/use-idle-timeout';

export const IdleTimeoutGuard = () => {
  const { showWarning, secondsLeft, stayLoggedIn, logoutNow } =
    useIdleTimeout();

  return (
    <IdleTimeoutModal
      open={showWarning}
      secondsLeft={secondsLeft}
      onStayLoggedIn={stayLoggedIn}
      onLogout={logoutNow}
    />
  );
};
